import React from "react";
import Button from "@mui/material/Button";
import { Trans } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../../../components/Common/Popup";

export default ({ open, handleConfirm, handleCancel, ...other }) => {
  return (
    <Popup
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      {...other}
    >
      <PopupHeading id="confirmation-dialog-title">
        <Trans>Change all pictures</Trans>
      </PopupHeading>
      <PopupContent dividers>
        <p>
          <Trans>
            Changing pictures in this package will replace all pictures with
            the selected picture.
          </Trans>
        </p>
        <p>
          <Trans>Click 'Replace pictures' to confirm the change.</Trans>
        </p>
      </PopupContent>
      <PopupActions>
        <PopupButton secondary onClick={handleCancel}>
          <Trans>Cancel</Trans>
        </PopupButton>

        <PopupButton autoFocus onClick={handleConfirm}>
          <Trans>Replace package pictures</Trans>
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};
